import { render, staticRenderFns } from "./GroupsBookingDetails.vue?vue&type=template&id=62487d3e&scoped=true&"
import script from "./GroupsBookingDetails.vue?vue&type=script&lang=ts&"
export * from "./GroupsBookingDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62487d3e",
  null
  
)

export default component.exports